import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { List } from 'foundations-components/transitional/components/List';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import styled, { css } from 'academy-common-lib/utils/Styling';
import I18n from 'I18n';
import usageTracker from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const linkStyle = css(["&:hover{text-decoration:underline !important;}"]);
const WhiteLink = styled(UILink).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "PublicPageBreadcrumbs__WhiteLink",
  componentId: "sc-1af6bhk-0"
})(["", ""], linkStyle);
const WhiteRouterLink = styled(UIRouterLink).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "PublicPageBreadcrumbs__WhiteRouterLink",
  componentId: "sc-1af6bhk-1"
})(["", ""], linkStyle);
const PublicPageBreadcrumbs = ({
  entries
}) => {
  const handleTrackBreadcrumbItemClick = href => () => {
    usageTracker.track('navInteraction', {
      action: 'breadcrumb-click',
      href
    });
  };
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": I18n.text('academyPublic.contentLandingPage.primaryDetails.breadcrumbs.ariaLabel'),
    children: /*#__PURE__*/_jsx(List, {
      inline: true,
      marginBlockEnd: "800",
      wrapChildren: true,
      children: entries.map(({
        name,
        href,
        to
      }, index) => /*#__PURE__*/_jsxs("span", {
        "data-test-id": "breadcrumb-item",
        children: [index !== 0 && /*#__PURE__*/_jsx(UIIcon, {
          name: "right",
          style: {
            marginRight: 6
          }
        }), href ? /*#__PURE__*/_jsx(WhiteLink, {
          href: href,
          onClick: handleTrackBreadcrumbItemClick(href),
          children: name
        }) : to ? /*#__PURE__*/_jsx(WhiteRouterLink, {
          onClick: handleTrackBreadcrumbItemClick(to),
          to: to || '',
          children: name
        }) : name]
      }, name))
    })
  });
};
export default PublicPageBreadcrumbs;